export const useAccordion = (detailsElement: HTMLDetailsElement) => {
  let summary = detailsElement.querySelector('summary') as HTMLElement;
  let content = detailsElement.querySelector('.accordion-block__content') as HTMLDivElement;
  let animation: Animation | null = null;
  let isClosing = false;
  let isExpanding = false;
  let animationDuration: number | string = 250;

  const onClick = (e: Event) => {
    e.preventDefault();
    detailsElement.style.overflow = 'hidden';

    if (isClosing || !detailsElement.open) {
      open();
    } else if (isExpanding || detailsElement.open) {
      shrink();
    }
  };

  const shrink = () => {
    isClosing = true;
    const startHeight = `${detailsElement.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (animation) {
      animation.cancel();
    }

    animation = detailsElement.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 150,
        easing: 'ease-out',
      }
    );

    animation.onfinish = () => onAnimationFinish(false);
    animation.oncancel = () => (isClosing = false);
  };

  const open = () => {
    detailsElement.style.height = `${detailsElement.offsetHeight}px`;
    detailsElement.open = true;

    window.requestAnimationFrame(() => expand());
  };

  const expand = () => {
    isExpanding = true;
    const startHeight = `${detailsElement.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

    if (animation) {
      animation.cancel();
    }

    animation = detailsElement.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: animationDuration,
        easing: 'ease-out',
      }
    );

    animation.onfinish = () => onAnimationFinish(true);
    animation.oncancel = () => (isExpanding = false);
  };

  const onAnimationFinish = (open: boolean) => {
    detailsElement.open = open;
    animation = null;
    isClosing = false;
    isExpanding = false;
    detailsElement.style.height = detailsElement.style.overflow = '';
  };

  summary.addEventListener('click', onClick);
};

// This is used to initialize the accordion on the page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('details').forEach((el) => {
    useAccordion(el as HTMLDetailsElement);
  });
});
